module.exports = __webpack_public_path__ + "img/bigData2.7c9acfee.jpg";